<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> نمودار تنخواه
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="imprest-chart"></chart-export-btn>
    </v-card-title>
    <canvas id="imprest-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'ImprestChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "شارژ شده",
              data: [],
              borderColor: "#FF8700",
              backgroundColor: "#FF8700",
              borderWidth: 3,
              hoverBorderWidth: 5
            },
            {
              label: "تصفیه شده",
              data: [],
              backgroundColor: "#002357",
              borderColor: "#002357",
              borderWidth: 3,
              hoverBorderWidth: 5
            },

          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if (parseInt(tooltipItem.yLabel) >= 1000) {
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .10)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function (value, index, values) {
                    if (parseInt(value) >= 1000) {
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }

                }
              }
            ]
          }
        }
      },
      chartResult : null,
    }
  },
  mounted() {
    this.getChartFromApi()

  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/imprestChartApi`),
        method: "get",
        success: data => {
          this.chartResult = data
          this.getData(data)
        }
      })
    },
    getData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' +
          this.financialYear.name
      this.chartData.options.title.fontSize =  this.titleSize

      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[1].data = []

      for (let account of data) {
        this.chartData.data.labels.push(account.name)
        this.chartData.data.datasets[0].data.push(account.transaction_amount)
        this.chartData.data.datasets[1].data.push(account.imprest_settlement_amount)
      }

      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('imprest-chart');
      new Chart(ctx, this.chartData);
    }

  },
  computed: {
    title(){
      return 'چک های پرداختنی'
    },
    titleSize() {
      if (this.main) {
        return 18
      } else {
        return 13
      }
    },
  },

}
</script>